import React from "react";
import { Card, CardContent, Typography, Divider, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
interface Props {
  totalItemValue:Number;
}
const ValueOfStock: React.FC<Props> = ({ totalItemValue }) => {
  return (
    <Card sx={{ backgroundColor: "#0D1B2A", color: "#ffffff", borderRadius: 1, padding: 1.7, minWidth: 250 }}>
      <CardContent>
        {/* Title */}
        <Typography variant="subtitle1" sx={{ color: "#B0BEC5" }}>
          Value of Stock
        </Typography>

        {/* Stock Value */}
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#ffffff", marginBottom: 2 }}>
        Rs. {totalItemValue?.toString()}
        </Typography>

        {/* Divider */}
        <Divider sx={{ backgroundColor: "#B0BEC5", marginBottom: 2 }} />

        {/* Stock Purchases Section */}
        <Typography variant="subtitle1" sx={{ color: "#B0BEC5", marginBottom: 1 }}>
          Stock Purchases
        </Typography>

        {/* Purchase Items */}
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" sx={{ color: "#ffffff" }}>Unfulfilled</Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" sx={{ marginRight: 1 }}>NA</Typography>
            <ArrowForwardIosIcon fontSize="small" sx={{ color: "#B0BEC5" }} />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" sx={{ color: "#ffffff" }}>Received</Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" sx={{ marginRight: 1 }}>NA</Typography>
            <ArrowForwardIosIcon fontSize="small" sx={{ color: "#B0BEC5" }} />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" sx={{ color: "#ffffff" }}>Pending</Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" sx={{ marginRight: 1 }}>NA</Typography>
            <ArrowForwardIosIcon fontSize="small" sx={{ color: "#B0BEC5" }} />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" sx={{ color: "#ffffff" }}>Completed</Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" sx={{ marginRight: 1 }}>NA</Typography>
            <ArrowForwardIosIcon fontSize="small" sx={{ color: "#B0BEC5" }} />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body1" sx={{ color: "#ffffff" }}>Cancelled</Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" sx={{ marginRight: 1 }}>NA</Typography>
            <ArrowForwardIosIcon fontSize="small" sx={{ color: "#B0BEC5" }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ValueOfStock;
